import { render, staticRenderFns } from "./adsAccountManagement.vue?vue&type=template&id=0831f4d6&scoped=true"
import script from "./adsAccountManagement.vue?vue&type=script&lang=js"
export * from "./adsAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./adsAccountManagement.vue?vue&type=style&index=0&id=0831f4d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831f4d6",
  null
  
)

export default component.exports